/* import __COLOCATED_TEMPLATE__ from './payment-modal.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from '../payment-modal.module.scss';

export default class SiteBillingPaymentInstrumentPaymentModal extends Component {
  styles = styles;

  @service billingModals;
  @service paymentInstrumentModals;
  @service currentPractice;
}
